/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Termincount1Inputs */

const en__field_termincount1 = /** @type {(inputs: _Field_Termincount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin count`)
};

const de__field_termincount1 = /** @type {(inputs: _Field_Termincount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Termine`)
};

/**
* | output |
* | --- |
* | "Termin count" |
*
* @param {_Field_Termincount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_termincount1 = /** @type {((inputs?: _Field_Termincount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Termincount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_termincount1(inputs)
	return de__field_termincount1(inputs)
});
export { _field_termincount1 as "_field_terminCount" }